package org.moxultimate.topwithmox.wallpaper.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WallpaperRequest(
    @SerialName("title") val title: String,
    @SerialName("description") val description: String,
    @SerialName("series") val series: String,
    @SerialName("type") val type: String,
    @SerialName("tags") val tags: String,
    @SerialName("resolution") val resolution: String,
    @SerialName("image") val imagePath: ByteArray = ByteArray(0),
    @SerialName("thumbnail") val thumbnailPath: ByteArray = ByteArray(0),
    @SerialName("panorama") val panoramaPath: ByteArray = ByteArray(0),
    @SerialName("video_link") val videoLink: String,
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class.js != other::class.js) return false

        other as WallpaperRequest

        if (title != other.title) return false
        if (description != other.description) return false
        if (series != other.series) return false
        if (type != other.type) return false
        if (tags != other.tags) return false
        if (resolution != other.resolution) return false
        if (!imagePath.contentEquals(other.imagePath)) return false
        if (!thumbnailPath.contentEquals(other.thumbnailPath)) return false
        if (!panoramaPath.contentEquals(other.panoramaPath)) return false
        if (videoLink != other.videoLink) return false

        return true
    }

    override fun hashCode(): Int {
        var result = title.hashCode()
        result = 31 * result + description.hashCode()
        result = 31 * result + series.hashCode()
        result = 31 * result + type.hashCode()
        result = 31 * result + tags.hashCode()
        result = 31 * result + resolution.hashCode()
        result = 31 * result + imagePath.contentHashCode()
        result = 31 * result + thumbnailPath.contentHashCode()
        result = 31 * result + panoramaPath.contentHashCode()
        result = 31 * result + videoLink.hashCode()
        return result
    }
}